import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "accordion-item" }
const _hoisted_2 = { class: "d-none" }
const _hoisted_3 = { class: "accordion-header px-3 d-flex justify-content-between align-items-center" }
const _hoisted_4 = ["data-bs-target"]
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "svg-icon svg-icon-3" }
const _hoisted_7 = { class: "svg-icon svg-icon-3" }
const _hoisted_8 = ["data-bs-target"]
const _hoisted_9 = { class: "svg-icon svg-icon-2x" }
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "accordion-body" }
const _hoisted_12 = { class: "my-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "Contract", -1)
const _hoisted_14 = { class: "my-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "Action", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "fs-3 fw-bold mb-2 ms-1" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Data: ")
const _hoisted_20 = { class: "svg-icon svg-icon-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "ms-10"
}
const _hoisted_23 = { class: "fs-5 fw-bold mb-2 ms-1" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = {
  key: 1,
  class: "card-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Authorization = _resolveComponent("Authorization")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.counter), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", {
        class: "fs-4 fw-bold mb-0 ms-4 py-6 w-50 w-md-100",
        "data-bs-toggle": "collapse",
        "data-bs-target": `#action_body${_ctx.index}`
      }, "Action " + _toDisplayString(_ctx.index+1) + " - " + _toDisplayString(_ctx.actionAlt.account) + "::" + _toDisplayString(_ctx.actionAlt.name), 9, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn btn-icon badge-light-success btn-color-success btn-sm me-1",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addAction(_ctx.actionAlt , _ctx.index)))
        }, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" })
          ])
        ]),
        _createElementVNode("button", {
          class: "btn btn-icon badge-light-danger btn-color-danger btn-sm me-1",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeAction(_ctx.index)))
        }, [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
          ])
        ]),
        _createElementVNode("span", {
          class: "accordion-icon ms-5",
          "data-bs-toggle": "collapse",
          "data-bs-target": `#action_body${_ctx.index}`
        }, [
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr071.svg" })
          ])
        ], 8, _hoisted_8)
      ])
    ]),
    _createElementVNode("div", {
      id: `action_body${_ctx.index}`,
      class: "accordion-collapse collapse",
      "aria-labelledby": "`action_body_${index}`",
      "data-bs-parent": "#copy_accordion"
    }, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.actionAlt.account) = $event)),
            class: "form-control form-control-solid",
            name: "contract",
            placeholder: "Enter contract"
          }, null, 512), [
            [_vModelText, _ctx.actionAlt.account]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.actionAlt.name) = $event)),
            class: "form-control form-control-solid",
            name: "action",
            placeholder: "Enter action"
          }, null, 512), [
            [_vModelText, _ctx.actionAlt.name]
          ])
        ]),
        _hoisted_16,
        _createElementVNode("div", null, [
          _createVNode(_component_Authorization, {
            data: _ctx.actionAlt.authorization,
            title: 'Authorization',
            onSetAuthorization: _ctx.setAuthorization
          }, null, 8, ["data", "onSetAuthorization"])
        ]),
        _hoisted_17,
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("button", {
              class: "btn btn-icon badge-light-success btn-color-success btn-sm me-1 ms-3",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.refreshData()))
            }, [
              _createElementVNode("span", _hoisted_20, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr029.svg" })
              ])
            ])
          ]),
          _hoisted_21,
          (!_ctx.dataLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "my-3"
                  }, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(index), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.data[index]) = $event),
                      class: "form-control form-control-solid",
                      name: "contract"
                    }, null, 8, _hoisted_24), [
                      [_vModelText, _ctx.data[index]]
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createVNode(_component_Loading, { height: '150px' })
              ]))
        ])
      ])
    ], 8, _hoisted_10)
  ]))
}